import React from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import ImmutablePureComponent from 'react-immutable-pure-component'
import Sticky from 'react-stickynode'
import { BREAKPOINT_EXTRA_SMALL, BREAKPOINT_MEDIUM, BREAKPOINT_SMALL, CX } from '../constants'
import { me } from '../initial_state'
import Layout from './layout'
import { expandMediaAttachmentsByGroupId } from '../actions/media_attachments'
import GroupHeader from '../components/group_header'
import SidebarPanelGroup from '../components/sidebar_panel_group'
import Responsive from '../features/ui/util/responsive_component'
import WrappedBundle from '../features/ui/util/wrapped_bundle'
import {
  LinkFooter,
  SignUpPanel,
  GroupsPanel,
  GroupInfoPanel,
  MediaGalleryPanel,
} from '../features/ui/util/async_components'
import { connect } from 'react-redux'

class GroupLayout extends ImmutablePureComponent {

  render() {
    const {
      children,
      group,
      groupId,
      relationships,
      title,
      moderationCount,
      requestsCount,
      showSidebar,
      sidebarChildren,
      width,
      actions,
    } = this.props

    const isXS = width <= BREAKPOINT_EXTRA_SMALL
    const isSmall = !isXS && width <= BREAKPOINT_SMALL
    const isMedium = !isXS && !isSmall && width <= BREAKPOINT_MEDIUM
    const isLarge = width >= BREAKPOINT_MEDIUM

    const showMedia = !!group && !!me && showSidebar ? group.get('is_media_visible') : false
    const mediaGalleryParams = !showMedia ? {} : {
      title: 'Group media',
      id: group.get('id'),
      type: 'group',
      to: `/groups/${group.get('id')}/media`,
      showFooterBtn: true,
      onExpand: expandMediaAttachmentsByGroupId,
    }

    const innerClasses = CX({
      d: 1, 
      px15: !showSidebar,
      w100PC: !showSidebar,
      w645PX: showSidebar, 
      mlAuto: 1,
      mrAuto: 1,
      z1: 1,
    })

    return (
      <Layout
        noRightSidebar
        showBackBtn
        title={title}
        actions={actions}
        noComposeButton={!showSidebar}
        sidebarChildren={sidebarChildren}
        page='group'
        search={{
          placeholder: 'Search for groups',
          to: '/search/groups',
        }}
      >

        {
          isXS &&
          <div className={[_s.d, _s.w100PC].join(' ')}>
            <GroupHeader
              isXS
              group={group}
              relationships={relationships}
              moderationCount={moderationCount}
              requestsCount={requestsCount}
            >
              <WrappedBundle component={GroupInfoPanel} componentParams={{ group, noPanel: true }} />
            </GroupHeader>

            <div className={[_s.d, _s.w100PC, _s.z1].join(' ')}>
              {children}
            </div>
          </div>
        }

        {
          !isXS &&
          <div className={[_s.d, _s.w100PC].join(' ')}>

            <GroupHeader
              group={group}
              isSmall={isSmall}
              relationships={relationships}
              moderationCount={moderationCount}
              requestsCount={requestsCount}
            />

            <div className={[_s.d, _s.flexRow, _s.w100PC, _s.jcEnd].join(' ')}>
              <div className={innerClasses}>
                <div className={_s.d}>
                  {children}
                </div>
              </div>
              {
                showSidebar && !isXS && !isSmall &&
                <div className={[_s.d, _s.w340PX].join(' ')}>
                  <Sticky top={73} enabled>
                    <div className={[_s.d, _s.w340PX, _s.pr15].join(' ')}>
                      <SidebarPanelGroup
                        page={`group.${groupId}`}
                        layout={[
                          <WrappedBundle key='group-layout-group-info-panel' component={GroupInfoPanel} componentParams={{ group }} />,
                          showMedia && <WrappedBundle component={MediaGalleryPanel} componentParams={mediaGalleryParams} />,
                          SignUpPanel,
                          GroupsPanel,
                          LinkFooter,
                        ].filter(Boolean)}
                      />
                    </div>
                  </Sticky>
                </div>
              }
            </div>
          </div>
        }
      </Layout>
    )
  }

}

const mapStateToProps = (state) => ({
  width: state.getIn(['settings', 'window_dimensions', 'width'])
})

GroupLayout.propTypes = {
  children: PropTypes.node,
  group: ImmutablePropTypes.map,
  groupId: PropTypes.string,
  relationships: ImmutablePropTypes.map,
  title: PropTypes.string,
  showSidebar: PropTypes.bool,
  moderationCount: PropTypes.number,
  requestsCount: PropTypes.number,
}

export default connect(mapStateToProps)(GroupLayout)
